import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2023©", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { href: "/dashboard?tour=1" }, "Dashboard guided tour", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", { class: "menu menu-gray-600 menu-hover-primary fw-bold order-1" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "menu-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://singlequote.net/",
      target: "_blank",
      class: "menu-link px-2"
    }, "Developed by Single Quote")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" Neoris "),
        (_ctx.showGuidedTour)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" - "),
              _hoisted_4
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ], 2)
  ]))
}